import { toggleListItemClass } from "./utils";

const getCurrentFilterValue = (filters) => {
    if(Object.keys(filters).length === 0) return;

    const filtersValues = [];

    for(const filterObj of Object.values(filters)) {
        if(filterObj.filterType !== "checkbox" || !filterObj.value) continue;

        filtersValues.push({ filterName: filterObj.filterName, value: filterObj.value });
    }

    if(filtersValues.length === 1 && filtersValues[0].value && filtersValues[0].value.length === 1) return { filterName: filtersValues[0].filterName, value: filtersValues[0].value[0] };
}

const getFilterCardByCurrentFilter = (filters, filterCards) => {
    const currentFilter = getCurrentFilterValue(filters);
    let currentFilterCard = null;
    
    if(!currentFilter) return null;
    
    for(const filterCard of filterCards) {
        if(filterCard.filterId && filterCard.filterId === currentFilter.value && filterCard.filterName && filterCard.filterName == currentFilter.filterName) {
            currentFilterCard = filterCard;
            break;
        }
    }

    return currentFilterCard;
}

export const filterFilterCards = (state) => {
    if(!state.filterCards || state.filterCards.length === 0) return;

    if(state.activeFilterCard)
        toggleListItemClass(state.activeFilterCard, "remove");
    
    state.activeFilterCard = getFilterCardByCurrentFilter(state.filters, state.filterCards);

    if(state.activeFilterCard)
        toggleListItemClass(state.activeFilterCard, "add");
}